import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { VideosAdminState } from "./types";
import { setResponseMessage } from "../adminSlice";

const initialState: VideosAdminState = {
  options: [],
  videos: [],
  video: undefined,
  loading: false,
};

const videosAdmin = createSlice({
  name: "videosAdminSlice",
  initialState,
  reducers: {
    setVideoForEdit(state, action) {
      state.video = action.payload;
      state.loading = false;
    },
    setOptions(state, action) {
      state.options = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setVideos(state, action) {
      state.videos = action.payload;
    },
  },
});
export const {
  setLoading,
  setOptions,
  setVideos,
  setVideoForEdit,
} = videosAdmin.actions;

export const selectLoading = (state: RootState) => state.videosAdmin.loading;

export const selectAllVideos = (state: RootState) => state.videosAdmin.videos;

export const selectVideoForEditing = (state: RootState) =>
  state.videosAdmin.video;

export const fetchAllVideos = () => async (dispatch: any) => {
  try {
    const res = await axios.get(`${API_URL}/admin/video`);

    dispatch(setVideos(res.data.data));
  } catch (error: any) {
    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addVideo = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);
    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/admin/video`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно качихте коментара.",
          hasError: false,
        })
      );
      dispatch(setLoading(false));
      dispatch(fetchAllVideos());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const updateVideo = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data.data);
    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/video/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно променихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllVideos());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const deleteVideo = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/admin/video/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllVideos());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const fetchVideo = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    let token = userStorage.getUser();
    const result = await axios.get(`${API_URL}/admin/video-values/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setVideoForEdit(result.data.data));
  } catch (error: any) {
    batch(() => {
      dispatch(setLoading(false));
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
    });
  }
};

export default videosAdmin.reducer;
